import {
    ALL_DEVICES_MODAL_PROPS_CHANGED,
    INCREASE_CREDIT_MODAL_PROPS_CHANGED,
    INCREASE_CREDIT_MODAL_PROPS_CLEARED,
    INCREASE_REPORT_MODAL_PROPS_CHANGED,
    MESSAGE_MODAL_PROPS_CHANGED,
} from '../actions/types';

const initialIncreaseCreditModalProps = {
    isVisible: false,
    successResponse: { message: '' },
    errorResponse: { message: '' },
    confirmation: { message: '' },
};

const initialState = {
    increaseReportModal: { isVisible: false },
    increaseCreditModal: initialIncreaseCreditModalProps,
    allDevicesModal: { isVisible: false },
    messageModal: { isVisible: false, isNewMessage: false },
};

const modals = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case INCREASE_REPORT_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                increaseReportModal: { ...state.increaseReportModal, ...payload },
            };
        }
        case INCREASE_CREDIT_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                increaseCreditModal: { ...state.increaseCreditModal, ...payload },
            };
        }
        case INCREASE_CREDIT_MODAL_PROPS_CLEARED: {
            return {
                ...state,
                increaseCreditModal: {
                    ...initialIncreaseCreditModalProps,
                },
            };
        }
        case ALL_DEVICES_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                allDevicesModal: { ...state.allDevicesModal, ...payload },
            };
        }
        case MESSAGE_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                messageModal: { ...state.messageModal, ...payload },
            };
        }
        default:
            return state;
    }
};

export default modals;
